import React from 'react';
import { View, Text } from 'react-native';
import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';

const ActionPopup = (props) => {
    const showPopup = props.showPopup
    const modalData = props?.modalData
    const closeModal = props.closeModal
    const primaryAction = props?.primaryAction
    const hasBackdrop = props?.hasBackdrop ?? true
    return (
        <Modal key={modalData.title} isVisible={showPopup}
            deviceHeight={AppTheme.modalHeight} hasBackdrop={hasBackdrop}
            onBackdropPress={() => closeModal()} backdropOpacity={AppTheme.modalBackdropOpacity}
            animationOut={"slideOutDown"} animationOutTiming={AppTheme.modalAnimationDuration}>
            <View style={AppStyles.modalContainer}>
                <Text style={[TextStyle.text18b]}>{modalData['title']}</Text>
                <Text style={[TextStyle.text16, { paddingTop: 4 }]}>
                    {modalData['subTitle']}</Text>
                <View style={[AppStyles.flexRowEnd, { paddingTop: 12 }]}>
                    <Text onPress={() => closeModal()}
                        style={[TextStyle.text16b, {
                            color: AppTheme.color.red.highlight
                        }]}>{modalData.secondaryCTATitle}
                    </Text>
                    <Text onPress={() => { closeModal(); primaryAction() }}
                        style={[TextStyle.text16b, {
                            color: AppTheme.color.primary, marginLeft: 32
                        }]}>{modalData.primaryCTATitle}
                    </Text>
                </View>
            </View>
        </Modal>
    )
}

export default ActionPopup